export const projeler = {
  title: 'Projeler',
  titleEN: 'Projects',
  description: 'Mackolik.com’da yayınlanan liste ve quiz içeriklerinden farklı olarak, teknik, tasarım ve content ekiplerinin çalışması sonucu oluşturulan, temel amacı marka ve kampanya bilinirliği arttırmak olan kullanıcı etkileşimli kurgulardır.',
  descriptionEN: 'Unlike the list and quiz content published on mackolik.com, these are user-interactive scenarios created through the collaboration of technical, design, and content teams, with the primary aim of increasing brand and campaign awareness.',
  tabs: [
    {
      id: 1,
      title: 'Content Based Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Transfer Kategorisi',
          image: 'https://srv-cdn.onedio.com/store/38360d8c89b304fcfbdea6d2f4768ed8a9b9c23b3dcb7ec8f8fcd573253765eb.png',
          modal: 'image',
          modalTitle: 'Transfer Kategorisi'
        },
        {
          id: 2,
          name: 'Sarı Kart Projesi',
          image: 'https://srv-cdn.onedio.com/store/45d557462a18ee3a370130ea1f1d2c29d33fb360bc776c9ce0515116de090013.png',
          modal: 'image',
          modalTitle: 'Sarı Kart Projesi'
        },
        {
          id: 3,
          name: 'Formula 1',
          image: 'https://srv-cdn.onedio.com/store/35c40f63008929757c43eb00cb17fb2eede2508f7224097fca5c4da857c696d1.png',
          modal: 'image',
          modalTitle: 'Formula 1'
        },
        {
          id: 4,
          name: 'Maçın Oyuncusu',
          image: 'https://srv-cdn.onedio.com/store/dd981107253f1d3a47b14439987a7b07697e5df73756e1a66f5990e271ed812b.png',
          modal: 'image',
          modalTitle: 'Maçın Oyuncusu'
        },
        {
          id: 5,
          name: 'Benim 11\'im',
          image: 'https://srv-cdn.onedio.com/store/30840d80ff1f7a390484e69d9bf0dc6b6c58df7705aab1a292a86d163e102d44.png',
          modal: 'image',
          modalTitle: 'Benim 11\'im'
        }
      ]
    },
    {
      id: 2,
      title: 'Rich Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/9bcd0530580394b4137c12b9097f8689b0edb4b7160108b5dfc6e1ac5fc36679.png',
          url: 'https://www.mackolik.com/canli-sonuclar?google_preview=MN7q5a-_aIcYp6rXxAYwp8aMzAaIAYCAgJC89tus5gE&iu=22860626436&gdfp_req=1&lineItemId=6829333867&creativeId=138500392528',
          category: 'Masthead Interaction RM'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/39ce7f357c7997bd05e88e3241ed133fb1a6098b8b251b683fcbe761a4bed9e3.png',
          url: 'https://www.mackolik.com/canli-sonuclar?google_preview=LwOBHcS_DMoYqKvXxAYwqMeMzAaIAYCAgJC89qf2Ng&iu=22860626436&gdfp_req=1&lineItemId=6829333867&creativeId=138500402506',
          category: 'Takeover Rich Media'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/24fadbf6decebfcbc427c58158caa121d928973b544ebcf71fddcf6dc0003c92.png',
          url: 'https://www.mackolik.com/canli-sonuclar?google_preview=v54uLidFR_wYjKzXxAYwjMiMzAaIAYCAgJC89qf1NA&iu=22860626436&gdfp_req=1&lineItemId=6829333867&creativeId=138499815014',
          category: 'Takeover Rich Media'
        },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/5fda0d54eb117513e5c314e081a10ae6d16576a91696c1cd209f3e05646646b9.png',
          url: 'https://www.mackolik.com/canli-sonuclar?google_preview=vqUyrQ8Ic4wYy6zXxAYwy8iMzAaIAYCAgJC89tfa2AE&iu=22860626436&gdfp_req=1&lineItemId=6829333867&creativeId=138499560987',
          category: 'Takeover Rich Media'
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Content Based Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Transfer Category',
          image: 'https://srv-cdn.onedio.com/store/38360d8c89b304fcfbdea6d2f4768ed8a9b9c23b3dcb7ec8f8fcd573253765eb.png',
          modal: 'image',
          modalTitle: 'Transfer Category'
        },
        {
          id: 2,
          name: 'Yellow Card Project',
          image: 'https://srv-cdn.onedio.com/store/45d557462a18ee3a370130ea1f1d2c29d33fb360bc776c9ce0515116de090013.png',
          modal: 'image',
          modalTitle: 'Yellow Card Project'
        },
        {
          id: 3,
          name: 'Formula 1',
          image: 'https://srv-cdn.onedio.com/store/35c40f63008929757c43eb00cb17fb2eede2508f7224097fca5c4da857c696d1.png',
          modal: 'image',
          modalTitle: 'Formula 1'
        },
        {
          id: 4,
          name: 'The Game\'s Player',
          image: 'https://srv-cdn.onedio.com/store/dd981107253f1d3a47b14439987a7b07697e5df73756e1a66f5990e271ed812b.png',
          modal: 'image',
          modalTitle: 'The Game\'s Player'
        },
        {
          id: 5,
          name: 'My 11',
          image: 'https://srv-cdn.onedio.com/store/30840d80ff1f7a390484e69d9bf0dc6b6c58df7705aab1a292a86d163e102d44.png',
          modal: 'image',
          modalTitle: 'My 11'
        }
      ]
    },
    {
      id: 2,
      title: 'Rich Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/9bcd0530580394b4137c12b9097f8689b0edb4b7160108b5dfc6e1ac5fc36679.png',
          url: 'https://www.mackolik.com/canli-sonuclar?google_preview=MN7q5a-_aIcYp6rXxAYwp8aMzAaIAYCAgJC89tus5gE&iu=22860626436&gdfp_req=1&lineItemId=6829333867&creativeId=138500392528',
          category: 'Masthead Interaction RM'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/39ce7f357c7997bd05e88e3241ed133fb1a6098b8b251b683fcbe761a4bed9e3.png',
          url: 'https://www.mackolik.com/canli-sonuclar?google_preview=LwOBHcS_DMoYqKvXxAYwqMeMzAaIAYCAgJC89qf2Ng&iu=22860626436&gdfp_req=1&lineItemId=6829333867&creativeId=138500402506',
          category: 'Takeover Rich Media'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/24fadbf6decebfcbc427c58158caa121d928973b544ebcf71fddcf6dc0003c92.png',
          url: 'https://www.mackolik.com/canli-sonuclar?google_preview=v54uLidFR_wYjKzXxAYwjMiMzAaIAYCAgJC89qf1NA&iu=22860626436&gdfp_req=1&lineItemId=6829333867&creativeId=138499815014',
          category: 'Takeover Rich Media'
        },
        {
          id: 4,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/5fda0d54eb117513e5c314e081a10ae6d16576a91696c1cd209f3e05646646b9.png',
          url: 'https://www.mackolik.com/canli-sonuclar?google_preview=vqUyrQ8Ic4wYy6zXxAYwy8iMzAaIAYCAgJC89tfa2AE&iu=22860626436&gdfp_req=1&lineItemId=6829333867&creativeId=138499560987',
          category: 'Takeover Rich Media'
        }
      ]
    }
  ]
}
